import { useRuntimeConfig } from '../internal';

export function useLoginAppUrl(): string {
  return useRuntimeConfig().loginAppUrl;
}
